export const howItWorks: string[] = [
  'Thirty statements about how you feel and relate',
  'Rate each one: Not Me At All through Totally Me!',
  'Answer with your first instinct, not how you wish you were',
  'Takes less than 5 minutes',
  'Enter your email to receive your full profile and join my newsletter (you can opt out of the newsletter at any time).',
]

export const profileNote =
  'Match scores above 70% indicate a strong pattern that consistently shapes your relational style. 45 to 69% signals meaningful presence. Most people carry two or three patterns in significant measure. A true zero on any archetype is meaningful: it suggests that pattern is genuinely inactive rather than simply less dominant.'

export const goDeeper = {
  heading: 'Want to go deeper?',
  body: 'Your archetype shapes how you experience the Drop, the pre-cognitive shame signal that fires before you can think. Understanding your pattern is where real relational change begins.',
}
